import type { IPersonaProps } from '@fluentui/react';

export interface IHorizontalPersonaProps extends IPersonaProps {
  vertical?: false;
}
